import { ReportFormat } from "./index";
import { DefaultReportFormat } from "./default";

export const ReportFormatList: ReportFormat[] = [
  DefaultReportFormat
];
